import React from 'react';
import { useSelector } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import { ContainerWrapper } from '../../components';
import CustomersList from './CustomersList/CustomersList';
import CustomerShow from './CustomerShow/CustomerShow';
import CustomerEdit from './CustomerEdit/CustomerEdit';
import CustomerCreate from './CustomerCreate/CustomerCreate';
import CustomerDelete from './CustomerDelete/CustomerDelete';

const Customers = ({ match }) => {
    const { setting } = useSelector(state => state.settings);

    return (
        <div className="Customers">
            <ContainerWrapper container="customers">
                {setting?.eshop?.registration?.enabled === false && <Redirect to="/admin" /> }
                <Route exact path={match.path} component={CustomersList} />
                <Route exact path={`${match.url}/new`} component={CustomerCreate} />
                <Route exact path={`${match.url}/show/:customerId`} component={CustomerShow} />
                <Route exact path={`${match.url}/edit/:customerId`} component={CustomerEdit} />
                <Route exact path={`${match.url}/delete/:customerId`} component={CustomerDelete} />
            </ContainerWrapper>
        </div>
    );
}

export default Customers;
